import { useApiErrorHandler } from '@/composables/useApiErrorHandler.js'
import { useApiRequestHelper } from '@/composables/useApiRequestHelper.js'
import { useRouter } from 'vue-router'

export function useLoginRedirect(axios) {
  const router = useRouter()
  const { apiUrlUnauthenticated } = useApiRequestHelper()
  const { handleErrors } = useApiErrorHandler(router)

  const redirectToLogin = async () => {
    try {
      const { api_url, login_token } = await axios
        .get(`${apiUrlUnauthenticated.value}/login-link`)
        .then(({ data }) => {
          return data.data
        })

      await router.push({
        name: 'login',
        params: { loginToken: login_token },
        query: { api_url },
      })
    } catch (error) {
      await handleErrors(error)
    }
  }

  return {
    redirectToLogin,
  }
}
